import React from 'react'

import TribologySamplesSearch from '../../../../components/Tribology/Samples/Search'

const PageTribologySamplesSearch = () => {
  return <TribologySamplesSearch />
}

export default PageTribologySamplesSearch
